import { Controller } from "@hotwired/stimulus";
import toastr from "toastr";

// flash はプレーンテキスト専用 (refs: libe-ms-todo#575)。HTML を渡しても描画させない
toastr.options.escapeHtml = true;

// RailsのFlashメッセージを表示するだけのコントローラー
// Connects to data-controller="toastr"
export default class extends Controller {
  static values = {
    flashKey: String, // フラッシュメッセージの種類
    message: String // フラッシュメッセージの内容
  }

  connect() {
    this.execute();
  }

  execute() {
    switch (this.flashKeyValue) {
      case 'notice':
      case 'info':
        toastr.info(this.messageValue);
        break;
      case 'alert':
      case 'error':
        toastr.error(this.messageValue);
        break;
      default:
        toastr.success(this.messageValue);
    }
  }
}
